import { memo } from 'react';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormPriceField } from './KioskFormPriceField/KioskFormPriceField';
import { WebFormPriceField } from './WebFormPriceField/WebFormPriceField';
import { FormPostalCodeFieldProps } from './FormPriceField.types';

const FormPostalCodeField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required,
    autoFocus,
    keyboardLayout = KeyboardLayouts.Price,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    externalRef,
    onChangeCallback,
    onBlurCallback,
    onFocusCallback,
}: FormPostalCodeFieldProps) => {
    return isElectron() ? (
        <KioskFormPriceField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            keyboardLayout={keyboardLayout}
            shiftAfterSpace={shiftAfterSpace}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            externalRef={externalRef}
            onChangeCallback={onChangeCallback}
            onFocusCallback={onFocusCallback}
            onBlurCallback={onBlurCallback}
        />
    ) : (
        <WebFormPriceField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            externalRef={externalRef}
            onChangeCallback={onChangeCallback}
            onFocusCallback={onFocusCallback}
            onBlurCallback={onBlurCallback}
        />
    );
});

export default FormPostalCodeField;